/** TanStack Query keys for Workers (ani-workers API). */

export const workersKeys = {
  all: ["workers"] as const,
  list: (view: "summary" | "full" = "summary") =>
    [...workersKeys.all, "list", view] as const,
  pinned: () => [...workersKeys.all, "pinned"] as const,
  card: (id: string) => [...workersKeys.all, "card", id] as const,
  open: (workerId: string, conversationId?: string | null) =>
    [...workersKeys.all, "open", workerId, conversationId ?? null] as const,
  conversations: (workerId: string) =>
    [...workersKeys.all, "conversations", workerId] as const,
  messages: (conversationId: string) =>
    [...workersKeys.all, "messages", conversationId] as const,
};
